import React, { Component } from "react";
import { connect } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import "./ViewCandidate.css";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import registrationlogo from '../pages/assets/registrationlogo.png';
import Sidelog from '../pages/assets/sidelogo.png';
import { imgBaseURL } from "../../src/actions/type"; // adjust path to where you exported it

// --- ACTIONS ---
import { getcandidate } from "../actions/candidateAction";
import { getintrestedcandidate, updateintrestedcandidate } from "../actions/IntrestedCandidateAction";
import {
  getshedulemeeting,
  createshedulemeeting,
} from "../actions/SheduleMeetingAction";
import { getsubsection } from "../actions/subsectionAction";
import { Form, Row, Col, Button, Container, Modal, Spinner, Alert } from 'react-bootstrap';

class ViewCandidate extends Component {
  constructor(props) {
    super(props);
    this.printRef = React.createRef();
    this.editFormRef = React.createRef();

    this.state = {
      showModal: false,
      showViewForm: false,
      showEditForm: false,
      viewFormData: null,
      editFormData: null,
      activeTab: "existing",
      selectedCandidate: null,
      meetingForm: {
        title: "",
        venue: "",
        date: "",
        time: "",
      },
      subsectionId: this.props.params.id || null,
      downloading: false,
      editing: false,
      editFormErrors: {},
      formModified: false
    };
  }

  componentDidMount() {
    const { subsectionId } = this.state;
    if (subsectionId) {
      this.props.getcandidate({ subsectionId });
      this.props.getintrestedcandidate();
      this.props.getsubsection();
    }
  }

  componentDidUpdate(prevProps) {
    const currentId = this.props.params.id;
    const prevId = prevProps.params.id;

    if (currentId !== prevId && currentId) {
      this.setState({ subsectionId: currentId });
      this.props.getcandidate({ subsectionId: currentId });
      this.props.getintrestedcandidate();
      this.props.getsubsection();
    }
  }

  // --- HANDLERS ---

  handleOpenSchedule = (candidate) => {
    this.setState({
      selectedCandidate: candidate,
      showModal: true,
      activeTab: "existing",
    });
    this.props.getshedulemeeting({});
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      selectedCandidate: null,
      meetingForm: { title: "", venue: "", date: "", time: "" },
    });
  };
  handleOpenViewForm = (interestedData) => {
    const { getintrestedcandidateList = [], getcandidateList = [] } = this.props;

    // Re-fetch latest interested object by id (preferred) or mobile
    const latestInterested =
      getintrestedcandidateList.find(ic => String(ic.id) === String(interestedData.id)) ||
      getintrestedcandidateList.find(ic => String(ic.mobile) === String(interestedData.mobile)) ||
      interestedData;

    // Optionally merge with matched candidate to fill partyName, etc.
    const matchedCandidate = getcandidateList.find(
      c => String(c.mobile) === String(latestInterested.mobile)
    );

    const mergedData = {
      ...latestInterested,
      partyName: latestInterested.partyName || matchedCandidate?.partyName,
      fullName: latestInterested.fullName || matchedCandidate?.fullName,
    };

    this.setState({
      viewFormData: mergedData,
      showViewForm: true,
    });
  };


  handleCloseViewForm = () => {
    this.setState({
      showViewForm: false,
      viewFormData: null,
    });
  };

  handleOpenEditForm = (interestedData) => {
    this.setState({
      editFormData: { ...interestedData },
      showEditForm: true,
      formModified: false,
      editFormErrors: {}
    });
  };

  handleCloseEditForm = () => {
    if (this.state.formModified) {
      if (window.confirm("You have unsaved changes. Are you sure you want to close?")) {
        this.setState({
          showEditForm: false,
          editFormData: null,
          formModified: false,
          editFormErrors: {}
        });
      }
    } else {
      this.setState({
        showEditForm: false,
        editFormData: null,
        formModified: false,
        editFormErrors: {}
      });
    }
  };

  handleEditInputChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      editFormData: {
        ...prevState.editFormData,
        [name]: value
      },
      formModified: true
    }));
  };

  downloadFile = async (fileUrl, customFileName) => {
    try {
      this.setState({ downloading: true });

      // 1. Fetch the file as a blob
      const response = await fetch(fileUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const blob = await response.blob();

      // 2. Determine extension (pdf, jpg, etc.)
      const extension = fileUrl.split('.').pop().split(/\#|\?/)[0];
      const fullFileName = `${customFileName}.${extension}`;

      // 3. Create a temporary link and trigger click
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fullFileName);

      // 4. Append to body, click, and cleanup
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Download failed, falling back to open:", error);
      // Fallback: If fetch fails (e.g., CORS issue), open in new tab
      window.open(fileUrl, '_blank');
    } finally {
      this.setState({ downloading: false });
    }
  };


  handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      this.setState(prevState => ({
        editFormData: {
          ...prevState.editFormData,
          [name]: files[0],
          [`${name}Preview`]: URL.createObjectURL(files[0])
        },
        formModified: true
      }));
    }
  };

  validateEditForm = () => {
    const { editFormData } = this.state;
    const errors = {};

    if (!editFormData.fullName?.trim()) errors.fullName = "Full Name is required";
    if (!editFormData.mobile?.trim()) errors.mobile = "Mobile is required";
    if (!editFormData.email?.trim()) errors.email = "Email is required";
    if (!editFormData.wardNo?.trim()) errors.wardNo = "Ward Number is required";
    if (!editFormData.seatNo?.trim()) errors.seatNo = "Seat Number is required";
    if (!editFormData.date?.trim()) errors.date = "Date is required";

    this.setState({ editFormErrors: errors });
    return Object.keys(errors).length === 0;
  };

  handleEditSubmit = (e) => {
    e.preventDefault();

    if (!this.validateEditForm()) {
      return;
    }

    this.setState({ editing: true });

    const formData = new FormData();
    const { editFormData } = this.state;

    // Append all form fields
    Object.keys(editFormData).forEach(key => {
      if (editFormData[key] instanceof File) {
        formData.append(key, editFormData[key]);
      } else if (editFormData[key] !== null && editFormData[key] !== undefined) {
        formData.append(key, editFormData[key]);
      }
    });

    // Make sure ID is included
    if (editFormData.id) {
      formData.append('id', editFormData.id);
    }

    this.props.updateintrestedcandidate(formData)
      .then(() => {
        this.setState({
          showEditForm: false,
          editFormData: null,
          editing: false,
          formModified: false
        });

        // Refresh the interested candidates list
        this.props.getintrestedcandidate();

        alert("Candidate information updated successfully!");
      })
      .catch(error => {
        console.error("Update error:", error);
        alert("Error updating candidate information. Please try again.");
        this.setState({ editing: false });
      });
  };

  handleDownloadPdf = async () => {
    // 1. Check if ref exists
    if (!this.printRef.current) return;

    // 2. Set loading state
    this.setState({ downloading: true });

    try {
      const element = this.printRef.current;

      // 3. Create Canvas from HTML
      // scale: 2 ensures high quality. useCORS: true allows external images to render.
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        scrollY: -window.scrollY, // Crucial for correct positioning if window is scrolled
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight
      });

      // 4. Initialize PDF
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');

      const imgWidth = 210; // A4 width in mm
      const pageHeight = 297; // A4 height in mm

      // Calculate total height of the canvas in PDF units
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      // 5. Add First Page
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // 6. Loop: Add extra pages while content remains
      while (heightLeft > 0) {
        // Move the image position up by one page height
        position = heightLeft - imgHeight;

        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      // 7. Save PDF
      const fileName = this.state.viewFormData?.fullName
        ? `${this.state.viewFormData.fullName}_Application.pdf`
        : 'Candidate_Form.pdf';

      pdf.save(fileName);

    } catch (error) {
      console.error("PDF Generation Error:", error);
      alert("Error generating PDF. Please check console.");
    } finally {
      // 8. Reset loading state
      this.setState({ downloading: false });
    }
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      meetingForm: {
        ...prevState.meetingForm,
        [name]: value,
      },
    }));
  };

  handleSelectExisting = (meeting) => {
    const { selectedCandidate } = this.state;
    if (!selectedCandidate) return;
    alert(`Meeting "${meeting.title}" selected for ${selectedCandidate.fullName}.`);
    this.handleCloseModal();
  };

  handleCreateSubmit = (e) => {
    e.preventDefault();
    const { selectedCandidate, meetingForm } = this.state;
    if (!selectedCandidate) return;

    const payload = {
      title: meetingForm.title,
      venue: meetingForm.venue,
      date: meetingForm.date,
      time: meetingForm.time,
      isactive: "active",
      created_by: localStorage.getItem("id"),
    };

    this.props.createshedulemeeting(payload);
    alert("Request Sent.");
    this.handleCloseModal();
    setTimeout(() => {
      this.props.getshedulemeeting({});
    }, 1000);
  };

  render() {
    const { getcandidateList, shedulemeetingList, subsectionList, getintrestedcandidateList } = this.props;
    const {
      showModal,
      showViewForm,
      showEditForm,
      viewFormData,
      editFormData,
      activeTab,
      selectedCandidate,
      meetingForm,
      subsectionId,
      downloading,
      editing,
      editFormErrors
    } = this.state;

    // FIND CURRENT SUBSECTION NAME
    const currentSubsection = subsectionList?.find(
      (s) => String(s.id) === String(subsectionId)
    );

    const formatNameToMarathi = (name) => {
      if (!name) return "";
      const lower = name.toLowerCase();
      const m = lower.match(/(\d+)/);
      if (m) return `प्रभाग क्रमांक ${m[1]}`;
      return name;
    };

    const marathiHeading = currentSubsection
      ? `${formatNameToMarathi(currentSubsection.name)}`
      : `प्रभाग क्रमांक ${subsectionId}`;

    const allCandidates = getcandidateList || [];
    const existingMeetings = shedulemeetingList || [];
    const allInterested = getintrestedcandidateList || [];

    const filteredCandidates = allCandidates.filter(
      (cand) => String(cand.subsectionId) === String(subsectionId)
    );

    return (
      <div className="vc-container">
        {/* ------------------ PAGE HEADING ------------------ */}
        <h1 className="vc-page-title">
          उमेदवार यादी – <span className="vc-ward-title">{marathiHeading}</span>
        </h1>

        {/* ------------------ NO CANDIDATE CASE ------------------ */}
        {filteredCandidates.length === 0 ? (
          <div className="vc-empty">
            या प्रभागामध्ये कोणतेही उमेदवार आढळले नाहीत.
          </div>) : (
          <div className="vc-grid">
            {filteredCandidates.map((candidate) => {
              const matchedInterested = allInterested.find(
                (ic) => String(ic.mobile) === String(candidate.mobile)
              );

              return (
                <div key={candidate.id} className="vc-card">
                  <div className={`vc-status-strip ${matchedInterested ? 'status-filled' : 'status-empty'}`}></div>

                  <div className="vc-card-body">
                    <div style={{ display: 'flex', gap: '15px' }}>
                      <div className="vc-card-avatar">
                        {candidate.fullName.charAt(0)}
                      </div>
                      <div>
                        <h3>{candidate.fullName}</h3>
                        <div style={{ fontSize: '12px', color: '#999' }}>{candidate.partyName || "Independent"}</div>
                      </div>
                    </div>

                    <div style={{ marginTop: '15px' }}>
                      <div className="vc-info-row">
                        <span>Mobile:</span>
                        <span>{candidate.mobile}</span>
                      </div>
                      <div className="vc-info-row">
                        <span>Status:</span>
                        <span style={{ color: matchedInterested ? 'green' : 'red', fontWeight: 'bold' }}>
                          {matchedInterested ? "Form Submitted" : "Pending"}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="vc-card-footer">
                    {/* VIEW BUTTON */}
                    {matchedInterested ? (
                      <button
                        className="vc-btn vc-btn-view"
                        onClick={() => this.handleOpenViewForm(matchedInterested)}
                        title="View Read-Only Form"
                      >
                        View
                      </button>
                    ) : (
                      <button className="vc-btn vc-btn-disabled" disabled>
                        View
                      </button>
                    )}



                    {/* SCHEDULE BUTTON */}
                    <button
                      className="vc-btn vc-btn-schedule"
                      onClick={() => this.handleOpenSchedule(candidate)}
                      title="Schedule Meeting"
                    >
                      Schedule
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* --- MODAL 1: SCHEDULE MEETING --- */}
        {showModal && (
          <div className="vc-modal-overlay">
            <div className="vc-schedule-modal">
              <div className="vc-modal-title-bar">
                <span>Schedule: {selectedCandidate?.fullName}</span>
                <button onClick={this.handleCloseModal} style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer' }}>X</button>
              </div>
              <div className="vc-tab-bar">
                <button
                  className={`vc-tab-btn ${activeTab === 'existing' ? 'active' : ''}`}
                  onClick={() => this.setState({ activeTab: 'existing' })}
                >Existing Meetings</button>
                <button
                  className={`vc-tab-btn ${activeTab === 'new' ? 'active' : ''}`}
                  onClick={() => this.setState({ activeTab: 'new' })}
                >Create New</button>
              </div>
              <div className="vc-modal-body-p">
                {activeTab === 'existing' && (
                  <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    {existingMeetings.length === 0 ? <p>No meetings found.</p> : (
                      <ul style={{ listStyle: 'none', padding: 0 }}>
                        {existingMeetings.map(m => (
                          <li key={m.id} style={{ padding: '10px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                              <strong>{m.title}</strong><br />
                              <small>{m.venue} | {m.date}</small>
                            </div>
                            <button className="vc-btn vc-btn-view" onClick={() => this.handleSelectExisting(m)}>Select</button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}
                {activeTab === 'new' && (
                  <form onSubmit={this.handleCreateSubmit}>
                    <label>Title</label>
                    <input name="title" className="vc-input-ctrl" onChange={this.handleInputChange} required />
                    <label>Venue</label>
                    <input name="venue" className="vc-input-ctrl" onChange={this.handleInputChange} required />
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <div style={{ flex: 1 }}>
                        <label>Date</label>
                        <input type="date" name="date" className="vc-input-ctrl" onChange={this.handleInputChange} required />
                      </div>
                      <div style={{ flex: 1 }}>
                        <label>Time</label>
                        <input type="time" name="time" className="vc-input-ctrl" onChange={this.handleInputChange} required />
                      </div>
                    </div>
                    <button type="submit" className="vc-btn vc-btn-view" style={{ width: '100%', marginTop: '10px' }}>Create & Schedule</button>
                  </form>
                )}
              </div>
            </div>
          </div>
        )}

        {/* --- MODAL 2: VIEW FORM --- */}
        {showViewForm && viewFormData && (
          <div className="vc-modal-overlay" style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0,0,0,0.5)',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1050
          }}>

            {/* CSS to hide scrollbars but allow scrolling */}
            <style>
              {`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;  /* IE and Edge */
          scrollbar-width: none;  /* Firefox */
        }
      `}
            </style>

            {/* MODAL CONTAINER */}
            <div
              className="bg-white shadow-lg rounded"
              style={{
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '95vh',
                maxWidth: '950px',
                minWidth: '900px',
                width: '100%',
                margin: '20px',
                overflow: 'hidden' // Prevents outer scrollbars
              }}
            >

              {/* 1. FIXED HEADER SECTION (Matches Edit Modal Style) */}
              <div
                className="d-flex justify-content-between align-items-center p-3 border-bottom bg-light"
                style={{ zIndex: 1100 }}
              >
                <div className="d-flex align-items-center">
                  <h5 className="mb-0 fw-bold">Candidate Application Details</h5>

                </div>
                <div>
                  <button
                    onClick={this.handleCloseViewForm}
                    className="btn btn-secondary shadow-sm me-2 mt-0 btn-sm"
                  >
                    ✕ Close
                  </button>
                  <button
                    onClick={this.handleDownloadPdf} // Ensure you have this function defined
                    className="btn btn-primary shadow-sm btn-sm"
                    disabled={this.state.downloading} // Assuming state has downloading boolean
                  >
                    {this.state.downloading ? 'Generating PDF...' : '⬇ Download PDF'}
                  </button>
                </div>
              </div>

              {/* 2. SCROLLABLE BODY SECTION */}
              <div
                className="hide-scrollbar"
                style={{
                  overflowY: 'auto',
                  flexGrow: 1,
                  backgroundColor: '#525659', // Dark grey background for PDF viewer feel
                  padding: '20px'
                }}
              >
                <div ref={this.printRef}>
                  {/* --- PAPER SHEET (Target for PDF) --- */}
                  <div
                    // Ensure: this.printRef = React.createRef();
                    className="paper-sheet shadow-lg p-2 bg-white mx-auto"
                    style={{
                      border: "2px solid black",
                      width: "100%",
                      backgroundColor: "white"
                    }}
                  >
                    <div style={{ border: "2px solid black" }}>

                      {/* HEADER BANNER */}
                      <div className="header-banner">
                        <img
                          src={registrationlogo}
                          alt="Shivsena Header"
                          style={{ width: "100%", height: "auto", display: "block" }}
                        />
                      </div>

                      <div className="p-4 content-body">
                        <Form>

                          {/* --- TOP SECTION: Date, ID, Photo --- */}
                          <div className="d-flex justify-content-between align-items-start mb-3">
                            <div className="w-75">

                              {/* Date & App No */}
                              <div className="d-flex align-items-center mb-2">
                                <Form.Label className="fw-bold me-2 mb-0">दिनांक :</Form.Label>
                                <div className="fw-bold border-bottom border-dark px-2" style={{ minWidth: "120px" }}>
                                  {viewFormData.date ? viewFormData.date.split('T')[0] : ""}
                                </div>

                                <Form.Label className="fw-bold ms-5 me-2 mb-0">
                                  अर्ज क्रमांक :
                                </Form.Label>
                                <div
                                  className="border border-dark px-3 py-1 bg-light fw-bold"
                                  style={{ minWidth: "100px" }}
                                >
                                  #{viewFormData.id || ""}
                                </div>
                              </div>

                              <div className="mt-3">
                                <p className="fw-bold mb-1">प्रती,</p>
                                <p className="fw-bold mb-1">मा. ना. एकनाथजी शिंदे साहेब</p>
                                <p className="fw-bold mb-0">
                                  शिवसेना मुख्यनेते तथा उपमुख्यमंत्री (महाराष्ट्र राज्य)
                                </p>
                              </div>

                              <div className="mt-3 text-start fw-bold">
                                <p className="fw-bold mb-0" style={{ textAlign: 'justify' }}>
                                  सप्रेम जय महाराष्ट्र ,<br />
                                  आगामी पिंपरी चिंचवड सार्वत्रिक निवडणूक २०२५-२६ ची निवडणूक
                                  लढविण्यास मी इच्छुक असून मी पक्षाशी एकनिष्ठपणे पक्षाचे काम करेल,
                                  पक्षाची ध्येय धोरणे माझ्यावर बंधनकारक राहतील तरी निवडणुकीमध्ये मी
                                  शिवसेना पक्षाचा संभाव्य उमेदवार म्हणून निवडणूक लढण्यास तयार आहे. तरी
                                  आपण माझ्या उमेदवारीचा विचार करून मला निवडणूक लढण्याची संधी मिळावी
                                  ही आपणास नम्र विनंती, माझी वैयक्तिक माहिती खालील प्रमाणे.
                                </p>
                              </div>
                            </div>

                            {/* PHOTO */}
                            <div className="photo-section text-center ms-3 d-flex flex-column align-items-center">
                              <div
                                className="photo-box mb-2"
                                style={{
                                  border: "2px solid black",
                                  width: "130px",
                                  height: "160px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  overflow: "hidden"
                                }}
                              >
                                {viewFormData.image ? (
                                  <img
                                    src={`${imgBaseURL}${viewFormData.image}`}
                                    alt="Candidate"
                                    className="photo-img"
                                    crossOrigin="anonymous"
                                    style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "cover" }}
                                  />
                                ) : (
                                  <span className="text-muted fw-bold">फोटो</span>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* --- PERSONAL INFO HEADER --- */}
                          <div className="text-center mb-3 position-relative header-wrapper">
                            <div className="d-flex align-items-center justify-content-center gap-3">
                              <img src={Sidelog} alt="logo" style={{ height: '30px' }} />
                              <div className="bg-danger text-white px-4 py-1 rounded-pill">
                                <h4 className="mb-0 fw-bold">माझी वैयक्तिक माहिती</h4>
                              </div>
                              <img src={Sidelog} alt="logo" style={{ height: '30px' }} />
                            </div>
                          </div>

                          {/* --- ROW 1: WARD / SEAT / PART / VOTER SR NO --- */}
                          <div className="d-flex align-items-center flex-wrap gap-2 mb-3">
                            <span className="fw-bold">प्रभाग क्र.</span>
                            <div className="fw-bold border-bottom border-dark px-2 text-center" style={{ width: "100px" }}>
                              {viewFormData.wardNo}
                            </div>

                            <span className="fw-bold ms-2">जागा अ/ब/क/ड</span>
                            <div className="fw-bold border-bottom border-dark px-2 text-center" style={{ width: "100px" }}>
                              {/* Logic to map 1,2,3,4 to Marathi Letters */}
                              {(!viewFormData.seatNo && !viewFormData.seatCode) ? "" :
                                (viewFormData.seatNo == "1" || viewFormData.seatCode == "1") ? "अ" :
                                  (viewFormData.seatNo == "2" || viewFormData.seatCode == "2") ? "ब" :
                                    (viewFormData.seatNo == "3" || viewFormData.seatCode == "3") ? "क" :
                                      (viewFormData.seatNo == "4" || viewFormData.seatCode == "4") ? "ड" :
                                        viewFormData.seatNo}
                            </div>

                            <span className="fw-bold ms-2">भाग क्र.</span>
                            <div className="fw-bold border-bottom border-dark px-2 text-center" style={{ width: "80px" }}>
                              {viewFormData.partNo}
                            </div>

                            <span className="fw-bold ms-2">मतदारयादीतील अ.क्र.</span>
                            <div className="fw-bold border-bottom border-dark px-2 text-center" style={{ width: "80px" }}>
                              {viewFormData.voterListNo}
                            </div>
                          </div>

                          {/* --- MEMBERSHIP NO --- */}
                          <div className="d-flex align-items-center mb-3">
                            <span className="fw-bold text-nowrap me-2">
                              शिवसेना पक्षाचे क्रियाशील / सक्रिय सभासद आहेत का असल्यास सभासद क्रमांक
                            </span>
                            <div className="fw-bold border-bottom border-dark px-2 flex-grow-1">
                              {viewFormData.membershipNo || ""}
                            </div>
                          </div>

                          {/* --- FULL NAME + EMAIL --- */}
                          <div className="d-flex mb-2" style={{ width: "100%" }}>
                            <div style={{ width: "70%" }} className="me-3 d-flex align-items-end">
                              <span className="fw-bold text-nowrap me-2">पूर्ण नाव</span>
                              <div className="fw-bold border-bottom border-dark px-1 w-100">
                                {viewFormData.fullName}
                              </div>
                            </div>
                            <div style={{ width: "30%" }} className="d-flex align-items-end">
                              <span className="fw-bold text-nowrap me-2">ई-मेल</span>
                              <div className="fw-bold border-bottom border-dark px-1 w-100">
                                {viewFormData.email}
                              </div>
                            </div>
                          </div>

                          {/* --- ADDRESS --- */}
                          <div className="mb-2 d-flex align-items-end">
                            <span className="fw-bold text-nowrap me-2">संपूर्ण पत्ता</span>
                            <div className="fw-bold border-bottom border-dark px-1 w-100">
                              {viewFormData.fullAddress}
                            </div>
                          </div>

                          {/* --- CASTE --- */}
                          <div className="mb-2 d-flex align-items-end">
                            <div className="d-flex align-items-end flex-grow-1 me-3">
                              <span className="fw-bold text-nowrap me-2 mb-1">जात /पोटजात</span>
                              <div className="fw-bold border-bottom border-dark px-1 w-100">
                                {viewFormData.caste}
                              </div>
                            </div>
                            <div className="d-flex align-items-center" style={{ paddingBottom: "2px" }}>
                              {/* CASTE CERTIFICATE */}
                              <div className="mb-2 d-flex align-items-end">
                                <span className="fw-bold text-nowrap me-2 mb-1">
                                  जात प्रमाणपत्राची प्रत:
                                </span>
                                {viewFormData.documentPdf ? (
                                  <div className="d-flex align-items-center gap-2">
                                    <a
                                      href={`${imgBaseURL}${viewFormData.documentPdf}`}
                                      target="_blank"
                                      rel="noreferrer"
                                      crossOrigin="same-origin"
                                      className="fw-bold text-decoration-underline"
                                    >
                                      View File
                                    </a>
                                    <button
                                      type="button"
                                      onClick={() => this.downloadFile(
                                        `${imgBaseURL}${viewFormData.documentPdf}`,
                                        `${viewFormData.fullName}_Caste_Certificate`
                                      )}
                                      className="btn btn-sm btn-outline-success py-0"
                                      style={{ fontSize: '0.8rem' }}
                                    >
                                      Download
                                    </button>
                                  </div>
                                ) : (
                                  <span className="text-muted small">Not Attached</span>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* --- MOBILE --- */}
                          <div className="mb-2 d-flex align-items-center flex-wrap">
                            <div className="d-flex align-items-end flex-grow-1 me-3 mb-2">
                              <span className="fw-bold text-nowrap me-2">मोबाईल नंबर</span>
                              <div className="fw-bold border-bottom border-dark px-1 w-100">
                                {viewFormData.mobile}
                              </div>
                            </div>
                          </div>

                          {/* --- DOB / AGE / EDUCATION --- */}
                          <div className="d-flex align-items-end mb-2 gap-3 flex-wrap">
                            <div className="d-flex align-items-end">
                              <span className="fw-bold text-nowrap me-2">जन्मतारीख :</span>
                              <div className="fw-bold border-bottom border-dark px-1 text-center" style={{ width: "140px" }}>
                                {viewFormData.dateOfBirth ? viewFormData.dateOfBirth.split('T')[0] : ""}
                              </div>
                            </div>
                            <div className="d-flex align-items-end">
                              <span className="fw-bold text-nowrap me-2">वय</span>
                              <div className="fw-bold border-bottom border-dark px-1 text-center" style={{ width: "60px" }}>
                                {viewFormData.age}
                              </div>
                            </div>
                            <div className="d-flex align-items-end flex-grow-1">
                              <span className="fw-bold text-nowrap me-2">शिक्षण</span>
                              <div className="fw-bold border-bottom border-dark px-1 w-100">
                                {viewFormData.education}
                              </div>
                            </div>
                          </div>

                          {/* --- OCCUPATION / INCOME --- */}
                          <div className="d-flex align-items-end mb-2 gap-3">
                            <div className="d-flex align-items-end flex-grow-1">
                              <span className="fw-bold text-nowrap me-2">व्यवसाय :</span>
                              <div className="fw-bold border-bottom border-dark px-1 w-100">
                                {viewFormData.occupation}
                              </div>
                            </div>
                            <div className="d-flex align-items-end flex-grow-1">
                              <span className="fw-bold text-nowrap me-2">वार्षिक उत्पन्न रु.</span>
                              <div className="fw-bold border-bottom border-dark px-1 w-100">
                                {viewFormData.annualIncome}
                              </div>
                            </div>
                          </div>

                          {/* --- PARTY POSITIONS --- */}
                          <div className="d-flex align-items-end mb-2 gap-2 flex-wrap">
                            <div className="d-flex align-items-end">
                              <span className="fw-bold text-nowrap me-2">शिवसेनेत किती वर्षे आहात ?</span>
                              <div className="fw-bold border-bottom border-dark px-1 text-center" style={{ width: "80px" }}>
                                {viewFormData.yearsInParty}
                              </div>
                            </div>
                            <div className="d-flex align-items-end flex-grow-1">
                              <span className="fw-bold text-nowrap me-2">शिवसेना पद</span>
                              <div className="fw-bold border-bottom border-dark px-1 w-100">
                                {viewFormData.partyPosition}
                              </div>
                            </div>
                            <div className="d-flex align-items-end flex-grow-1">
                              <span className="fw-bold text-nowrap me-2">शासकीय पद:</span>
                              <div className="fw-bold border-bottom border-dark px-1 w-100">
                                {viewFormData.govtPosition}
                              </div>
                            </div>
                          </div>

                          <div className="mb-2 d-flex align-items-end">
                            <span className="fw-bold text-nowrap me-2">यापूर्वी कोणत्या पदावर काम केले</span>
                            <div className="fw-bold border-bottom border-dark px-1 w-100">
                              {viewFormData.previousPosition}
                            </div>
                          </div>

                          <div className="mb-2 d-flex align-items-end">
                            <span className="fw-bold text-nowrap me-2">इतर सामाजिक कार्य</span>
                            <div className="fw-bold border-bottom border-dark px-1 w-100">
                              {viewFormData.socialWork}
                            </div>
                          </div>

                          {/* --- SPENDING CAPACITY --- */}
                          <div className="mb-4 d-flex align-items-end">
                            <span className="fw-bold text-nowrap me-2">खर्चाची तयारी</span>
                            <div className="fw-bold border-bottom border-dark px-1 w-100">
                              {viewFormData.spendingCapacity || viewFormData.privateInfo || ""}
                            </div>
                          </div>

                          {/* --- WARD DETAILS HEADER --- */}
                          <br />
                          <div className="text-center mb-3 position-relative header-wrapper">
                            <div className="d-flex align-items-center justify-content-center gap-3">

                              <div className="bg-danger text-white px-4 py-1 rounded-pill">
                                <h4 className="mb-0 fw-bold">प्रभागातील सविस्तर माहिती</h4>
                              </div>

                            </div>
                          </div>


                          <div className="text-center text-danger fw-bold mb-3">प्रभागातील आरक्षणे</div>

                          <Row className="mb-3 g-3">
                            <Col md={6}><div className="d-flex align-items-end"><span className="fw-bold me-2">१) अ</span><div className="fw-bold border-bottom border-dark px-1 w-100">{viewFormData.A}</div></div></Col>
                            <Col md={6}><div className="d-flex align-items-end"><span className="fw-bold me-2">२) ब</span><div className="fw-bold border-bottom border-dark px-1 w-100">{viewFormData.B}</div></div></Col>
                            <Col md={6}><div className="d-flex align-items-end"><span className="fw-bold me-2">३) क</span><div className="fw-bold border-bottom border-dark px-1 w-100">{viewFormData.C || viewFormData.resC}</div></div></Col>
                            <Col md={6}><div className="d-flex align-items-end"><span className="fw-bold me-2">४) ड</span><div className="fw-bold border-bottom border-dark px-1 w-100">{viewFormData.D || viewFormData.resD}</div></div></Col>
                          </Row>

                          <div className="text-center text-danger fw-bold mb-3 mt-4">२०१७ प्रभागांमधील माजी नगरसेवक</div>

                          <Row className="mb-3 g-3">
                            <Col md={6}><div className="d-flex align-items-end"><span className="fw-bold me-2">१) अ) पक्ष</span><div className="fw-bold border-bottom border-dark px-1 w-100">{viewFormData.A_party}</div></div></Col>
                            <Col md={6}><div className="d-flex align-items-end"><span className="fw-bold me-2">२) ब) पक्ष</span><div className="fw-bold border-bottom border-dark px-1 w-100">{viewFormData.B_party}</div></div></Col>
                            <Col md={6}><div className="d-flex align-items-end"><span className="fw-bold me-2">३) क) पक्ष</span><div className="fw-bold border-bottom border-dark px-1 w-100">{viewFormData.C_party}</div></div></Col>
                          </Row>

                          <div className="d-flex align-items-end mb-2 gap-3 mt-4">
                            <div className="d-flex align-items-end flex-grow-1">
                              <span className="fw-bold text-nowrap me-2">प्रभागांमधील मतदारांची संख्या</span>
                              <div className="fw-bold border-bottom border-dark px-1 w-100">{viewFormData.total_votars}</div>
                            </div>
                            <div className="d-flex align-items-end flex-grow-1">
                              <span className="fw-bold text-nowrap me-2">प्रभागाची लोकसंख्या</span>
                              <div className="fw-bold border-bottom border-dark px-1 w-100">{viewFormData.ward_popul}</div>
                            </div>
                          </div>

                          <div className="mb-2 d-flex align-items-end">
                            <span className="fw-bold text-nowrap me-2">प्रभागातील सर्व यादी भाग क्रमांक</span>
                            <div className="fw-bold border-bottom border-dark px-1 w-100">{viewFormData.all_list_part_numbers}</div>
                          </div>

                          <div className="mb-2 d-flex align-items-end">
                            <span className="fw-bold text-nowrap me-2">प्रभागातील विशेष माहिती</span>
                            <div className="fw-bold border-bottom border-dark px-1 w-100">{viewFormData.special_info}</div>
                          </div>

                          <div className="mb-4 d-flex align-items-end">
                            <span className="fw-bold text-nowrap me-2">मागील निवडणुकीत मिळालेल्या मतांची संख्या</span>
                            <div className="fw-bold border-bottom border-dark px-1 w-100">{viewFormData.votes_receive_previously}</div>
                          </div>

                          {/* --- DECLARATION --- */}
                          <div className="text-center mb-3 position-relative header-wrapper">
                            <div className="d-flex align-items-center justify-content-center gap-3">

                              <div className="bg-danger text-white px-4 py-1 rounded-pill">
                                <h4 className="mb-0 fw-bold">प्रतिज्ञापत्र / हमीपत्र</h4>
                              </div>

                            </div>
                          </div>


                          <div className="mt-3 text-start fw-bold">
                            <div className="d-flex align-items-end mb-1">
                              <span className="fw-bold me-2 text-nowrap">मी. श्री / सौ.</span>
                              <div className="fw-bold border-bottom border-dark px-1 flex-grow-1">{viewFormData.fullName}</div>
                            </div>
                            <br />
                            <p className="mb-0 fw-bold" style={{ lineHeight: "1.6", textAlign: "justify" }}>
                              सत्य प्रतिज्ञेवर लिहून देतो की, वरील माहिती सत्य व बरोबर आहे मा.ना.एकनाथजी शिंदे साहेब शिवसेना मुख्य नेते व उपमुख्यमंत्री (महाराष्ट्र राज्य) आणि स्थानिक लोकप्रतिनिधी व वरिष्ठ पदाधिकाऱ्यांच्या आदेशाचे वेळोवेळी पालन करून संघटना वाढविण्यासाठी मी प्रयत्न करेल आपल्या पक्षाने दिलेले आदेश आमच्यासाठी बंधनकारक असतील. हा अर्ज म्हणजे उमेदवारी नाही हे मला माहित आहे. मी नागरिकांसाठी केलेले समाजकार्य व राजकीय कामाचा अनुभव असल्यामुळे उमेदवारी दिल्यास मी निवडून येण्यासाठी जास्तीत जास्त प्रयत्न करीन. माझ्या ऐवजी दुसऱ्या इच्छुक उमेदवारास उमेदवारी दिल्यास पक्षादेश मानून त्या उमेदवाराच्या विजयासाठी प्रामाणिकपणे मनापासून प्रयत्न करीन. तसेच कोणत्याही प्रकारची बंडखोरी व गैरवर्तन करणार नाही. मी उमेदवारी अर्ज फक्त शिवसेनेकडेच केला असून अन्य पक्ष/संघटना आघाडीकडे अर्ज केलेला नाही. त्यामुळे माझ्या अर्जाचा सहानुभूतीपूर्वक विचार करावा ही नम्र विनंती धन्यवाद.
                            </p>
                          </div>

                          {/* --- FOOTER: SIGNATURE / DATE --- */}
                          <div className="d-flex justify-content-between align-items-end mt-4">
                            <div className="w-50 mb-3">
                              <div className="d-flex align-items-end mb-3">
                                <span className="fw-bold me-2 text-nowrap">दिनांक :</span>
                                <div className="fw-bold border-bottom border-dark px-1 w-50">
                                  {viewFormData.date ? viewFormData.date.split('T')[0] : ""}
                                </div>
                              </div>
                              <div className="d-flex align-items-end">
                                <span className="fw-bold me-2 text-nowrap">ठिकाण :</span>
                                <div className="fw-bold border-bottom border-dark px-1 w-50">
                                  {viewFormData.place}
                                </div>
                              </div>
                            </div>

                            <div className="w-50 text-end">
                              <div className="d-flex align-items-center justify-content-end mb-3" style={{ minHeight: "50px" }}>
                                <span className="fw-bold me-2 text-nowrap"> इतर कागदपत्र :</span>
                                <div style={{ width: "180px", height: "50px", borderBottom: "1px solid #000", display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
                                  {/* Check if otherDocumentPdf is an image (often used for signature in this data structure) */}
                                  {/* OTHER DOCUMENT */}
                                  <div className="mb-2 d-flex align-items-center">
                                    {viewFormData.otherDocumentPdf ? (

                                      <div className="d-flex align-items-center gap-2">
                                        <a
                                          href={`${imgBaseURL}${viewFormData.otherDocumentPdf}`}
                                          target="_blank"
                                          rel="noreferrer"
                                          crossOrigin="same-origin"
                                          className="fw-bold text-decoration-underline"
                                        >
                                          View File
                                        </a>
                                        <button
                                          type="button"
                                          onClick={() => this.downloadFile(
                                            `${imgBaseURL}${viewFormData.otherDocumentPdf}`,
                                            `${viewFormData.fullName}_Other_Doc`
                                          )}
                                          className="btn btn-sm btn-outline-success py-0"
                                          style={{ fontSize: '0.8rem' }}
                                        >
                                          Download
                                        </button>
                                      </div>
                                    ) : (
                                      <span className="text-muted small">Not Attached</span>
                                    )}
                                  </div>

                                </div>
                              </div>
                              <div className="d-flex align-items-end justify-content-end">
                                <span className="fw-bold me-2 text-nowrap">नाव: श्री/सौ.</span>
                                <div className="fw-bold border-bottom border-dark px-1 w-50">
                                  {viewFormData.fullName}
                                </div>
                              </div>
                            </div>
                          </div>

                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div >
        )
        }



      </div>
    );
  }
}

// --- REDUX STATE MAPPING ---
const mapStateToProps = (state) => ({
  getcandidateList: state.candidate.getcandidate,
  shedulemeetingList: state.shedulemeeting.shedulemeeting,
  getintrestedcandidateList: state.intrestedcandidate.intrestedcandidate,
  subsectionList: state.subsection.subsection,
});

// --- WRAPPER FOR ROUTER V6 ---
const withRouter = (Component) => {
  return (props) => {
    const params = useParams();
    const navigate = useNavigate();
    return <Component {...props} params={params} navigate={navigate} />;
  };
};

export default connect(mapStateToProps, {
  getcandidate,
  getintrestedcandidate,
  getshedulemeeting,
  createshedulemeeting,
  getsubsection,
  updateintrestedcandidate,
})(withRouter(ViewCandidate));